import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Cookie } from "lucide-react";
import { useLang } from "@/lib/i18n";
import { analyticsConfigured, getConsent, setConsent } from "@/lib/analytics";

export const ConsentBanner = () => {
  const { t } = useLang();
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (!analyticsConfigured()) return undefined;
    if (!getConsent()) setOpen(true);
    const reopen = () => setOpen(true);
    window.addEventListener("vlx-consent-open", reopen);
    return () => window.removeEventListener("vlx-consent-open", reopen);
  }, []);

  if (!open) return null;
  const choose = (v) => { setConsent(v); setOpen(false); };
  return (
    <div data-testid="consent-banner" role="dialog" aria-live="polite" aria-label="Privacy choice"
      className="fixed inset-x-3 bottom-3 z-50 mx-auto max-w-xl rounded-2xl border border-slate-200 bg-white p-4 shadow-2xl sm:bottom-5">
      <p className="flex items-start gap-2 text-sm leading-relaxed text-slate-700">
        <Cookie className="mt-0.5 h-4 w-4 shrink-0 text-brand" />
        <span>{t("consent_text")} <Link to="/privacy" className="font-semibold text-brand underline">{t("consent_more")}</Link></span>
      </p>
      <div className="mt-3 grid grid-cols-2 gap-2">
        <button data-testid="consent-reject" onClick={() => choose("denied")}
          className="min-h-[44px] rounded-full border-2 border-slate-200 text-sm font-semibold text-slate-700 hover:border-brand">
          {t("consent_reject")}
        </button>
        <button data-testid="consent-accept" onClick={() => choose("granted")}
          className="min-h-[44px] rounded-full bg-brand text-sm font-semibold text-white hover:bg-brand-hover">
          {t("consent_accept")}
        </button>
      </div>
    </div>
  );
};
